import { parsePhoneNumber } from 'awesome-phonenumber'

import Validator from 'validator'

/** 
 * @function isEmail verifies that a string is an email address
 * @param {string} email email to be validated
 */
const isEmail = ( v ) => {
  try {
    return v == null ? false : Validator.isEmail( v )
  } catch ( err ) {
    return false
  }
}

// If there are parentheses, there must be an opening one followed by a closing one to be valid
const isValidParentheses = ( str ) => {
  const balanced = str.split( '' ).reduce( ( acc, char ) => {
    if ( acc < 0 ) return acc
    if ( char === '(' ) return acc + 1
    if ( char === ')' ) return acc - 1
    return acc
  }, 0 )
  return balanced === 0
}

/**
 * @function isPhone verifies that a string is a phone number
 * @param {string} phone phone number to be validated
 */
const isPhone = ( v, returnPhoneObject = false ) => {
  try {
    if ( v == null || typeof v !== 'string' ) {
      return false
    }
    if ( v.trim().length < 10 ) {
      return false
    }

    // remove all spacing from inputted number
    const phone = v.trim().replace( /\s+/g, '' )

    // only allows digits and certain phone related special characters: ()-.+
    const sanitized = /^[\d\-().+]+$/
    if ( !sanitized.test( phone ) ) {
      return false
    }
    if ( !isValidParentheses( phone ) ) {
      return false
    }
    // Ensure there are no parentheses without digits inside
    const invalidParentheses = /\(\D*\)/
    if ( invalidParentheses.test( phone ) ) {
      return false
    }

    // If country code is provided, use it, otherwise default to US
    const pn = v.trim().startsWith( '+' ) ? parsePhoneNumber( v ) : parsePhoneNumber( v, { regionCode : 'US' } )
    return returnPhoneObject ? pn : pn.valid
  } catch ( err ) { }
  return false
}

/**
 * @function optional Converts a validator function into optional by allowing v == null or an empty string to return true
 * @param {function} validator validator to be changed to allow null
 **/
const optional = ( validator ) => {
  return ( v ) => {
    if ( v == null || ( typeof v === 'string' && v.trim().length === 0 ) ) {
      return true
    }
    return validator( v )
  }
}

const required = ( v ) => {
  if ( v == null || ( typeof v === 'string' && v.trim().length === 0 ) ) {
    return false
  }

  return true
}

export default {
  isEmail,
  isPhone,
  optional,
  required,
}
